/// <amd-module name="SuiteCommerce.CustomFields.Checkout.Types"/>
define("SuiteCommerce.CustomFields.Checkout.Types", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
